// extracted by mini-css-extract-plugin
export default {"container":"BreadCrumbs__container___gyVID","interactiveSecondary":"BreadCrumbs__interactiveSecondary___AMYYp","button":"BreadCrumbs__button___IgWRc"};